<template>
    <div v-html="policyList">
    </div>
</template>
<script>
import { 
    apiGetLanlordPolicy,
    apiEditLandlordPolicy,
    apiDeleteLandlordPolicy
} from "@/apis/api.js"; 

export default {
    data () {
        return {
            policyList: null
        }
    },
    mounted() { 
        this.$analytics.logEvent('預設條款', { screen_name: '預設條款'})
        this.getPolicy()
    },
    methods: {
        getPolicy: function () {
            apiGetLanlordPolicy()
            .then(res =>{
                // console.log(res)
                if(res.data.status = 'SUCCESS'){
                    this.policyList = res.data.result.landlordHousePolicyDto.defaultHousePolicy
                }else{
                    console.log('Policy err')
                }
            })
            .catch(err =>{
                console.log(err)
            })
        },
    }
}
</script>
<style lang="">
    
</style>


// WEBPACK FOOTER //
// src/pages/landlord/DefaultPolicy.vue